// src/hooks/useInvites.js
import { useState, useEffect } from "react";
import { message, Modal } from "antd";
import { fetchInvites, sendInvite } from "PlatForms/OrgLMS/Services/ManagerService/inviteService";
import { resendInvite } from "PlatForms/OrgLMS/Services/ManagerService/inviteService";

export const useInvites = () => {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });

  const getInvites = async (page = 1) => {
    try {
      setLoading(true);
      const data = await fetchInvites({ pageNumber: page, pageSize: pagination.pageSize });
      setInvites(data.items || []);
      setPagination({
        totalCount: data.totalCount,
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
        totalPages: data.totalPages,
      });
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || "Failed to fetch invites");
      message.error("Failed to fetch invites");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    getInvites(page);
  };

  const handleResend = (inviteId) => {
    let modal = null; // reference for updating modal props

    modal = Modal.confirm({
      title: "Are you sure you want to resend the invitation?",
      content: "This will resend the invitation to the user.",
      okText: "Resend",
      cancelText: "Cancel",
      okButtonProps: {
        loading: false, // initial loading false
      },
      onOk: async () => {
        try {
          modal.update({
            okButtonProps: { loading: true },
          });

          await resendInvite(inviteId)

          message.success("Invitation resent successfully!");
          await getInvites();
        } catch (error) {
          console.log("Error", error);
        } finally {
          modal.update({
            okButtonProps: { loading: false },
          });
        }
      },
    });
  };

  const handleSendInvite = async (inviteData) => {
    try {
      const response = await sendInvite(inviteData);
      await getInvites();
      return { success: true, data: response };
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          return { success: false, error: data };
        }
      }
      throw error;
    }
  };

  useEffect(() => {
    getInvites();
  }, []);

  return {
    invites,
    loading,
    error,
    getInvites,
    handleResend,
    handleSendInvite,
    pagination,
    handlePageChange,
  };
};
